import React from 'react'
import styled from '@emotion/styled'
import tw from 'tailwind.macro'
import BlockContent from '../block-content'
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion'

function FaqAccordion(props) {
  const FaqAccordion = styled(Accordion)`
    border: 0;
    border-radius: 0px;
    ${tw`pb-6`};
  `
  const FaqItem = styled(AccordionItem)`
    ${tw`my-1`};
  `
  const FaqHeading = styled(AccordionItemHeading)``
  const FaqQuestion = styled(AccordionItemButton)`
    ${tw`text-black font-bold py-4 pl-6 pr-4`};
    ${tw`relative block`};
    background-color: #f5f5f5;
    ${tw`border-2 border-hr-quartz`};
    ${tw`outline-none`};
    ${tw`underline`};
    &:hover {
      ${tw`text-hr-red`};
      background-color: #eee;
    }
    &:focus {
      outline: 1px solid #888;
    }
    &:before {
      display: inline-block;
      content: '';
      height: 10px;
      width: 10px;
      margin-right: 12px;
      border-bottom: 2px solid currentColor;
      border-right: 2px solid currentColor;
      transform: rotate(-45deg);
      transition: all 0.3s ease-in-out;
    }
    &[aria-expanded='true']::before {
      transform: rotate(45deg);
      transition: all 0.3s ease-in-out;
    }
    &[aria-selected='true']::before {
      transform: rotate(45deg);
      transition: all 0.3s ease-in-out;
    }
  `
  const FaqAnswer = styled(AccordionItemPanel)`
    padding: 20px;
    animation: fadein 0.3s ease-in;

    & ol {
      ${tw`ml-4 pb-5`};
      list-style: decimal;
    }
    & p {
      ${tw`pb-4`};
      ${tw`leading-normal`};
    }
    & a {
      ${tw`text-hr-blue font-bold`};
    }
  `
  return (
    <FaqAccordion allowMultipleExpanded="true" allowZeroExpanded="true">
      {props._rawFaqs.map((faq) => {
        return (
          <FaqItem>
            <FaqHeading>
              <FaqQuestion>{faq.title}</FaqQuestion>
            </FaqHeading>
            <FaqAnswer>
              <BlockContent blocks={faq.faqAnswer || []} />
            </FaqAnswer>
          </FaqItem>
        )
      })}
    </FaqAccordion>
  )
}

export default FaqAccordion
